import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createCategory,
  getAllCategories,
  deleteCategory,
  toggleCategoryStatus,
} from "../../actions/categoryActions";
import { deleteItemsByCategoryId } from "../../actions/itemActions";
import { useSnackbar } from "react-simple-snackbar";
import {
  Typography,
  TextField,
  Button,
  Container,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Switch,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,

} from "@material-ui/core";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { makeStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        <FirstPageIcon />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        <LastPageIcon />
      </IconButton>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 500,
  },
  tablecell: {
    fontSize: "16px",
  },
  inputContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  addCategoryButton: {
    margin: theme.spacing(2),
    marginTop: theme.spacing(2.5),
  },

  
}));

const Categories = ({categories}) => {
  const [newCategoryName, setNewCategoryName] = useState("");
  const dispatch = useDispatch();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  // const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    return parseInt(localStorage.getItem("rowsPerPage")) || 5;
  });
  const [page, setPage] = useState(0);
  const classes = useStyles();
  // const { categories } = useSelector((state) => state.categories);
  const [openDialog, setOpenDialog] = useState(false); // New state for dialog
  const handleAddCategory = () => {
    if (newCategoryName) {
      dispatch(createCategory({ categoryName: newCategoryName }));
      setNewCategoryName("");
      setOpenDialog(false); // Close dialog after adding
      window.location.reload();
      openSnackbar("Category Created successfully");
    }
  };
  // useEffect(() => {
  //   if (!categories.length) {
  //     dispatch(getAllCategories());
  //   }
  // }, [dispatch, categories]);
  const tableStyle = {
    width: 160,
    fontSize: 14,
    cursor: "pointer",
    borderBottom: "none",
    padding: "8px",
    textAlign: "center",
  };
  const headerStyle = { borderBottom: "none", textAlign: "center" };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };
  const handleToggleStatus = (id, currentStatus) => {
    dispatch(toggleCategoryStatus(id));
    openSnackbar(
      `Category ${currentStatus ? "deactivated" : "activated"} successfully`
    );
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setNewCategoryName(""); // Reset input when closing
  };

  useEffect(() => {
    localStorage.setItem("rowsPerPage", rowsPerPage);
  }, [rowsPerPage]);
  // const handleDelete = async(id) => {
  //   const confirmDelete = window.confirm(
  //    "Are you sure you want to delete this category and all associated items?"
  //   );
  //   if (confirmDelete) {
  //   // dispatch(deleteItemsByCategoryId(id, openSnackbar));
  //    dispatch(deleteCategory(id, openSnackbar));

  //   }
  // };

  const handleDelete = async (id, isActive) => {
    if (!isActive) return; // Prevent delete if inactive
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category and all associated items?"
    );
    if (confirmDelete) {
      dispatch(deleteCategory(id, openSnackbar));
    }
  };
  // const filteredCategories = categories.filter(c => c.categoryName!=="Services")
  // const filteredCategories = categories.filter(
  //   (c) => c.categoryName !== "Services" && !c.isDeleted
  // ); // Filter out deleted categories in UI
  return (
    <Container maxWidth="md" className={classes.container}>
      <Box>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenDialog}
          className={classes.addCategoryButton}
          startIcon={<AddIcon />}
        >
          Add Category
        </Button>
      </Box>

      {/* Dialog for adding new category */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Add New Category</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Category Name"
            variant="outlined"
            fullWidth
            value={newCategoryName}
            onChange={(e) => setNewCategoryName(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAddCategory} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
      <TableContainer component={Paper}
          elevation={0}
          style={{ width: "100%", overflowX: "auto" }}>
        <Table className={classes.table} aria-label="custom pagination table">
          <TableHead className={classes.stickyHeader}>
            <TableRow>
              <TableCell style={headerStyle}>Sr#</TableCell>
              <TableCell style={headerStyle}>Name</TableCell>
              {/* <TableCell style={headerStyle}>Delete</TableCell> */}
              <TableCell style={headerStyle}>Active/Inactive</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {(rowsPerPage > 0
              ? categories?.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : categories
            ).map((row, index) => (
              <TableRow
                key={row._id}
                style={{ cursor: "pointer", opacity: row.isActive ? 1 : 0.5 }}
              >
                <TableCell
                style={tableStyle}
                >
                 {(page * rowsPerPage) + index + 1}
                </TableCell>
                <TableCell style={tableStyle} scope="row">
                  <Button
                    style={{ textTransform: "none" }}
                  >
                    {row.categoryName}
                  </Button>
                </TableCell>
                {/* hide no more use */}
                {/* <TableCell style={{ ...tableStyle, width: "10px" }}>
                  <IconButton  disabled={!row.isActive || row.categoryName === "Services"}
                    onClick={() => handleDelete(row._id, row.isActive)}>
                    <DeleteOutlineRoundedIcon
                      style={{ width: "20px", height: "20px" }}
                    />
                  </IconButton>
                </TableCell> */}

                <TableCell style={{ ...tableStyle, width: "10px" }}>
                  <Switch
                    checked={row.isActive}
                    onChange={() => handleToggleStatus(row._id, row.isActive)}
                    color="primary"
                    inputProps={{ "aria-label": "category status toggle" }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={6}
                  count={categories.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { "aria-label": "rows per page" },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
        </Table>
      </TableContainer>
    </Container>
  );
};

export default Categories;
